import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { AwardProjectHireMeState } from '../user-profile-award-project.types';

@Component({
  standalone: false,
  selector: 'app-user-profile-hire-me-action-state',
  template: `
    @if (awardProjectHireMeState$ | flAsync; as state) {
      <div [ngSwitch]="state">
        <ng-content
          *ngSwitchCase="AwardProjectHireMeState.LOADING"
          select="[loading-state]"
        ></ng-content>
        <ng-content
          *ngSwitchCase="AwardProjectHireMeState.HIRE_ME"
          select="[hire-me-state]"
        ></ng-content>
        <ng-content
          *ngSwitchCase="AwardProjectHireMeState.AWARD_PROJECT"
          select="[award-project-state]"
        ></ng-content>
      </div>
    }
  `,
  styleUrls: ['./user-profile-hire-me-action-state.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserProfileHireMeActionStateComponent {
  AwardProjectHireMeState = AwardProjectHireMeState;

  @Input() awardProjectHireMeState$: Observable<AwardProjectHireMeState>;
}
